// extracted by mini-css-extract-plugin
module.exports = {"mobileBreakpoint":"480px","giftCodeSection":"GiftRedeemPage_giftCodeSection__WSd2v"};